var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToCart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.51597 13.8263H7.51693C7.51773 13.8263 7.51854 13.8262 7.51934 13.8262H18.6738C18.9484 13.8262 19.1899 13.644 19.2653 13.38L21.7263 4.76668C21.7793 4.58099 21.7421 4.38136 21.626 4.22723C21.5097 4.0731 21.3278 3.98242 21.1348 3.98242H6.09709L5.65729 2.00326C5.59465 1.72176 5.34503 1.52148 5.05664 1.52148H1.36523C1.02541 1.52148 0.75 1.7969 0.75 2.13672C0.75 2.47654 1.02541 2.75195 1.36523 2.75195H4.56317C4.64103 3.10267 6.66778 12.2232 6.78442 12.7479C6.13057 13.0321 5.67187 13.6841 5.67187 14.4414C5.67187 15.4591 6.49987 16.2871 7.51757 16.2871H18.6738C19.0136 16.2871 19.2891 16.0117 19.2891 15.6719C19.2891 15.332 19.0136 15.0566 18.6738 15.0566H7.51757C7.17839 15.0566 6.90234 14.7806 6.90234 14.4414C6.90234 14.1027 7.17743 13.8271 7.51597 13.8263ZM20.3191 5.21289L18.2097 12.5957H8.01104L6.37042 5.21289H20.3191Z",
    fill: "#AE0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90234 18.1328C6.90234 19.1505 7.73035 19.9785 8.74805 19.9785C9.76575 19.9785 10.5937 19.1505 10.5937 18.1328C10.5937 17.1151 9.76575 16.2871 8.74805 16.2871C7.73035 16.2871 6.90234 17.1151 6.90234 18.1328ZM8.74805 17.5176C9.08723 17.5176 9.36328 17.7936 9.36328 18.1328C9.36328 18.472 9.08723 18.748 8.74805 18.748C8.40887 18.748 8.13281 18.472 8.13281 18.1328C8.13281 17.7936 8.40887 17.5176 8.74805 17.5176Z",
    fill: "#AE0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5977 18.1328C15.5977 19.1505 16.4257 19.9785 17.4434 19.9785C18.4611 19.9785 19.2891 19.1505 19.2891 18.1328C19.2891 17.1151 18.4611 16.2871 17.4434 16.2871C16.4257 16.2871 15.5977 17.1151 15.5977 18.1328ZM17.4434 17.5176C17.7825 17.5176 18.0586 17.7936 18.0586 18.1328C18.0586 18.472 17.7825 18.748 17.4434 18.748C17.1042 18.748 16.8281 18.472 16.8281 18.1328C16.8281 17.7936 17.1042 17.5176 17.4434 17.5176Z",
    fill: "#AE0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0.75 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCart);
export default __webpack_public_path__ + "static/media/add-to-cart.1ae16c7f3035144abeecb0998e4f2b6a.svg";
export { ForwardRef as ReactComponent };